
const state = {
    dialog: false
  }
  const mutations = {
    showDisclaimer(state) {
      console.log("Commit disclaimer")
      setTimeout(() =>{
        state.dialog = true
      }, 2000)
    },
    hideDisclaimer(state){
      state.dialog = false
    }
  }
  const  actions = {
  }
  const getters = {
    dialog: state => {
      return state.dialog
    },
  }
  
  export default {
    state,
    actions,
    getters,
    mutations
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/disclaimer.js